// Configuración de las áreas emocionales
export const emotionalAreas = [
  {
    id: 'TRISTEZA',
    name: 'Tristeza / Bajo Ánimo',
    description: 'Sentimientos de decaimiento, pérdida de interés o dificultad para disfrutar.',
    icon: 'heart-broken',
    color: '#6363d1',
    groupId: '151772866030864380',
    redirectUrl: 'https://jpsicologo.com/gracias-tristeza',
    consequences: [
      'Disminución del interés en actividades que antes disfrutabas',
      'Cambios en el apetito o peso significativos',
      'Sensación constante de vacío o desesperanza',
      'Dificultad para concentrarse o tomar decisiones'
    ],
    recommendations: [
      'Establece una rutina diaria estructurada',
      'Intenta realizar al menos una actividad placentera cada día',
      'Busca conexión social, incluso cuando no te apetezca',
      'Considera la terapia cognitivo-conductual como tratamiento efectivo'
    ]
  },
  {
    id: 'ANSIEDAD',
    name: 'Ansiedad',
    description: 'Preocupación excesiva, nerviosismo, tensión o dificultades para relajarse.',
    icon: 'alert-circle',
    color: '#00bcd4',
    groupId: '147239564675647074',
    redirectUrl: 'https://jpsicologo.com/gracias-ansiedad',
    consequences: [
      'Tensión muscular crónica y problemas físicos asociados',
      'Dificultades de concentración por pensamientos intrusivos',
      'Evitación de situaciones que generan ansiedad',
      'Agotamiento debido a la activación constante del sistema nervioso'
    ],
    recommendations: [
      'Practica técnicas de respiración diafragmática diariamente',
      'Identifica y cuestiona pensamientos catastróficos',
      'Reduce el consumo de cafeína y estimulantes',
      'Aprende técnicas de relajación progresiva muscular'
    ]
  },
  {
    id: 'ESTRES',
    name: 'Estrés / Sobrecarga',
    description: 'Sensación de agotamiento, presión constante o dificultad para desconectar.',
    icon: 'zap',
    color: '#ff9800',
    groupId: '151772855318611808',
    redirectUrl: 'https://jpsicologo.com/gracias-estres',
    consequences: [
      'El rendimiento laboral o académico puede deteriorarse progresivamente',
      'Las relaciones personales pueden verse afectadas por cambios en tu comportamiento',
      'Los problemas de sueño tienden a empeorar, creando fatiga y más estrés',
      'Pueden aparecer problemas digestivos y tensión muscular crónica'
    ],
    recommendations: [
      'Identifica las fuentes específicas de estrés para abordarlas directamente',
      'Establece límites claros entre trabajo y descanso',
      'Incorpora ejercicio moderado en tu rutina, al menos 20 minutos al día',
      'Practica la atención plena (mindfulness) en actividades cotidianas'
    ]
  },
  {
    id: 'RUPTURA_PAREJA',
    name: 'Ruptura de Pareja',
    description: 'Malestar emocional relacionado con el fin de una relación de pareja.',
    icon: 'heart',
    color: '#e91e63',
    groupId: '151772845840532957',
    redirectUrl: 'https://jpsicologo.com/gracias-ruptura-pareja',
    consequences: [
      'Pensamientos recurrentes sobre la relación y la ruptura',
      'Cambios significativos en rutinas y hábitos diarios',
      'Dificultades para confiar en nuevas relaciones',
      'Sentimientos intensos de soledad o abandono'
    ],
    recommendations: [
      'Permite expresar el duelo sin juzgarte por ello',
      'Evita el contacto innecesario con tu ex-pareja al inicio',
      'Reconstruye gradualmente tu identidad individual',
      'Busca apoyo en personas cercanas que respeten tu proceso'
    ]
  },
  {
    id: 'AUTOESTIMA',
    name: 'Autoestima / Confianza',
    description: 'Sentimientos de inseguridad, autocrítica excesiva o valoración personal negativa.',
    icon: 'star',
    color: '#9c27b0',
    groupId: '153297987729098333',
    redirectUrl: 'https://jpsicologo.com/gracias-autoestima',
    consequences: [
      'Tendencia a evitar desafíos por miedo al fracaso',
      'Dificultad para expresar opiniones o necesidades',
      'Comparación constante con otros generando malestar',
      'Mayor vulnerabilidad ante críticas externas'
    ],
    recommendations: [
      'Practica el diálogo interno compasivo frente a errores',
      'Identifica tus fortalezas y apóyate en ellas',
      'Establece pequeños desafíos graduales para construir confianza',
      'Rodéate de personas que valoren tus cualidades positivas'
    ]
  },
  {
    id: 'INSOMNIO',
    name: 'Insomnio / Problemas de Sueño',
    description: 'Dificultad para conciliar o mantener el sueño, despertares frecuentes o sueño no reparador.',
    icon: 'moon',
    color: '#536dfe',
    groupId: '153298004395165600',
    redirectUrl: 'https://jpsicologo.com/gracias-insomnio',
    consequences: [
      'Deterioro del rendimiento cognitivo y tiempos de reacción',
      'Mayor irritabilidad y cambios de humor durante el día',
      'Propensión a enfermedades por debilitamiento del sistema inmune',
      'Incremento del estrés y ansiedad creando un ciclo negativo'
    ],
    recommendations: [
      'Establece un horario constante para acostarte y levantarte',
      'Crea una rutina relajante antes de dormir de al menos 30 minutos',
      'Evita pantallas al menos 1 hora antes de acostarte',
      'Mantén el dormitorio oscuro, silencioso y a temperatura adecuada'
    ]
  }
];
